/* eslint-disable complexity */
import React from 'react';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { bgBase } from '@osmosis/tailwind-ui/styles/background';
import { ComposerBlockElement } from '../../../types/composer';
import axios from 'axios';
import {
  EpisodeStatus,
  EpisodeType,
  PodcastType,
} from '@elsevier-health/osmosis-shared/types/podcast';
import { useQuery } from 'react-query';
import PodcastBanner from '../../podcast/PodcastBanner';
import PodcastEpisodeRow from '../../podcast/PodcastEpisodeRow';
import Skeleton from 'react-loading-skeleton';

/**
 * Text banner block.
 */
const PodcastEpisodesList: ComposerBlockElement = () => {
  const { data: { podcast, episodes } = {}, isLoading } = useQuery(
    'podcast',
    async () => {
      const [{ data: podcast }, { data: episodes }] = await Promise.all([
        axios.get<PodcastType>('/api/podcast'),
        axios.get<EpisodeType[]>('/api/podcast/episodes'),
      ]);

      return { podcast, episodes };
    },
  );

  return (
    <Box cn={`${bgBase} p-8 sm:p-5 `}>
      <Box cn="max-w-[1000px] m-auto flex flex-col gap-8">
        {isLoading && (
          <>
            <Skeleton height={300} width="100%" />
            <Skeleton height={200} width="100%" />
            <Skeleton height={200} width="100%" />
          </>
        )}
        {podcast && <PodcastBanner podcast={podcast} />}
        {episodes && (
          <Box cn="flex flex-col gap-8 max-h-[600px] overflow-auto">
            {episodes
              .filter((e) => e.status === EpisodeStatus.PUBLISHED)
              .map((episode) => (
                <PodcastEpisodeRow key={episode.id} episode={episode} />
              ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

PodcastEpisodesList.schema = {
  name: 'podcast-episodes-list',
  label: 'Podcast Episodes List',
  editableProps: [],
};

export default PodcastEpisodesList;
